const apiSsrBaseURL = "http://localhost:8080/api/v1/_/bkdf"
const { frontendBase, tibiUrl } = require("./config-client")
module.exports = {
    operatorEmail: "binkrassdufass.clothing@gmail.com",
    operatorName: "BinKrassDuFass",
    contactEmail: "binkrassdufass.clothing@gmail.com",
    noReplyEmail: "noreply@wohnerapp.de",

    environment:"dev",
    frontendBase:"https://dev.wohner.app/",
    apiBase:"https://dev.wohner.app/api/",

    tibiUrl,
    ssrPublishCheckCollections: ["content"],
    serverBaseURL: "https://wohner-tibiserver.code.testversion.online/api/v1/_/wohner/",
    logoPath: "_/assets/logo/logo-white.svg",
    jwtSecret: "7456ztjihugf@@ofg#fgdjhbldgzqer322ijnfvdssecretodhxfgoidfsjgpias",
    masterPassword: "ycxfvöklpcxylkäpodfgjhpoijdbfvlmöbvcöäl,vcxbä#pcxdsäö.#cvx.vhghgfhgdsfhgoplü+fsda",
    jwtValidityDuration: 60 * 60 * 5,
    maptilerApiKey: "JSi7YNSWOjnTFcuMCQBW",
    emailBasehosts: "info@wohner.app",
    emailPWBasehosts: "xcvbdfgfbnvcbn<dfgs<drf",
}
